import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  DataRoomFileShellDocument,
  DataRoomFileShellQuery,
  DataRoomFileShellQueryVariables,
} from "@/src/graphql/generated";
import useGqlClient from "@/src/hooks/useGqlClient";

const STALE_TIME = 60_000;

export function usePrefetchDataRoomFileShell(fileId: string, delayMs = 150) {
  const client = useGqlClient();
  const queryClient = useQueryClient();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => clear, []);

  const prefetch = () => {
    if (!fileId) {
      return;
    }

    void queryClient.prefetchQuery({
      queryKey: ["DataRoomFileShell", { id: fileId }],
      queryFn: () =>
        client.request<DataRoomFileShellQuery, DataRoomFileShellQueryVariables>(
          DataRoomFileShellDocument,
          { id: fileId },
        ),
      staleTime: STALE_TIME,
    });
  };

  return {
    onMouseEnter: () => {
      clear();
      timerRef.current = setTimeout(prefetch, delayMs);
    },
    onMouseLeave: clear,
    onFocus: prefetch,
  };
}
